export class Popup {
	loadPopup(url)
	{
		$.ajax({
			type: "GET",
			url: url,
			dataType: 'html',
			success: function(data)
			{
				$('.popup[data-popup-name=popup-example] .popup__card').append(data);
				$(".popup[data-popup-name=popup-example]").addClass("active");
				$("body").addClass("no-scroll");
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}
	
	showPopup(name)
	{
		$(".popup[data-popup-name='" + name + "']").addClass("active");
		$("body").addClass("no-scroll");
	}
}